/** @format */

import images from "../../ImageVariables";
import Radio from "../../QuestionTypesComponent/Radio";
import ViewAllQuestionsMobileView from "../../ViewAllQuestionsMobileView";
import { componentProps } from "../QuestionsMobileViewPropsTypes";
import "../SCSS/styles.css";
import {
  EnumQuestionType,
  EnumSurveyAnswerStatus,
  EnumTypeTexts,
} from "../../Common/Enums/EnumsTypes";
import DOMPurify from "dompurify";
import { truncateString } from "../../Common/CommonFunctions/TruncateString";
import { ActionKind } from "../../SupplierView/SupplierViewPropsTypes";
import icons from "../../Assets/Icons/icons";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import DropDown from "../../QuestionTypesComponent/DropDown";
import StarRating from "../../QuestionTypesComponent/StarRating";
import CheckBox from "../../QuestionTypesComponent/Checkbox";
import Number from "../../QuestionTypesComponent/Number";
import TextBox from "../../QuestionTypesComponent/TextBox";
import DateAndTime from "../../QuestionTypesComponent/DateAndTime";
import Matrix from "../../QuestionTypesComponent/Matrix";
import FileUpload from "../../QuestionTypesComponent/FileUpload";
import Percentage from "../../QuestionTypesComponent/Percentage";
import CustomForm from "../../QuestionTypesComponent/CustomForm";

function QuestionsMobileView({
  handleViewAllQuestions,
  viewAll,
  handleAllQuestions,
  allQuestions,
  handleChangeBackButton,
  reducerState,
  questionObjVariable,
  handlePrevAndNextQuestion,
  currentQuestion,
  oldOption,
  checkNestedDependency,
  dependencyAnsHash,
  dispatch,
  isPreview,
  mainRefObject,
  setDependencyAnsHash,
  surveyAnswers,
  setSurveyAnswers,
  surveyAnswersInfo,
  handleChangeAddComment,
  confirmDeleteFile,
  handleClearAnswer,
  clearValuesFromSurveyAnswers,
  handleQuestionsToRender,
  outsideClickRef,
  disableButton,
  removeAttachedFile,
  handleNoteComment,
}: componentProps) {
  function renderQuestionTypes(questionId: string) {
    switch (questionObjVariable?.[questionId]?.questionType) {
      case EnumQuestionType.CHECKBOX:
        return (
          <CheckBox
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            mainRefObject={mainRefObject}
            checkNestedDependency={checkNestedDependency}
            isPreview={isPreview}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            clearValuesFromSurveyAnswers={clearValuesFromSurveyAnswers}
            dispatch={dispatch}
            reducerState={reducerState}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );

      case EnumQuestionType.RADIO:
        return (
          <Radio
            oldOption={oldOption}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            checkNestedDependency={checkNestedDependency}
            isPreview={isPreview}
            mainRefObject={mainRefObject}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            dispatch={dispatch}
            reducerState={reducerState}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.RATING:
        return (
          <StarRating
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.DROP_DOWN:
        return (
          <DropDown
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            oldOption={oldOption}
            mainRefObject={mainRefObject}
            checkNestedDependency={checkNestedDependency}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            dispatch={dispatch}
            reducerState={reducerState}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.TEXT:
        return (
          <TextBox
            questionId={questionId}
            surveyAnswers={surveyAnswers}
            isPreview={isPreview}
            setSurveyAnswers={setSurveyAnswers}
            mainRefObject={mainRefObject}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.NUMBER:
        return (
          <Number
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.DATE:
        return (
          <DateAndTime
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.MATRIX:
        return (
          <Matrix
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.FILE:
        return (
          <FileUpload
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswersInfo={surveyAnswersInfo}
            reducerState={reducerState}
            dispatch={dispatch}
            removeAttachedFile={removeAttachedFile}
            surveyAnswers={surveyAnswers}
          />
        );
      case EnumQuestionType.PERCENTAGE:
        return (
          <Percentage
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionId={questionId}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.CUSTOM_FORM:
        return (
          <CustomForm
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswersInfo={surveyAnswersInfo}
            dispatch={dispatch}
            surveyAnswers={surveyAnswers}
          />
        );
      default:
        return null;
    }
  }

  const percentage =
    ((currentQuestion + 1) / reducerState.questionIdsToRender.length) * 100;

  return (
    <div className="questions-mobile-view-main-container">
      <div className="questions-mobile-view-header-container">
        <div
          className="questions-mobile-view-back-button"
          onClick={() => {
            handleChangeBackButton();
          }}
        >
          <img
            src={images.back}
            alt="back"
            style={{ height: "50%", width: "50%" }}
          />
        </div>
        {!allQuestions ? (
          <div className="questions-mobile-view-heading">Questions</div>
        ) : (
          <div className="questions-mobile-view-all-question-heading">
            View all questions
          </div>
        )}
        {!viewAll && !allQuestions ? (
          <div
            className={
              viewAll
                ? "questions-mobile-view-all-question-button"
                : "mobile-view-render-questions"
            }
            onClick={() => handleViewAllQuestions()}
          >
            {" "}
            <img
              src={images.dot}
              alt="dot"
              style={{ height: "35%", width: "35%" }}
            />
          </div>
        ) : (
          <div
            className="questions-mobile-view-all-questions"
            ref={outsideClickRef}
            onClick={() => {
              handleAllQuestions();
            }}
          >
            {!allQuestions && (
              <div className="mobile-view-all-questions">
                &nbsp;
                <img src={images.square} alt="prev-arrow" />
                &nbsp;<span>All Questions</span> &nbsp;
              </div>
            )}
          </div>
        )}
      </div>
      {allQuestions ? (
        <div className="mobile-view-all-questions-only">
          <ViewAllQuestionsMobileView
            reducerState={reducerState}
            questionObjVariable={questionObjVariable}
            handleQuestionsToRender={handleQuestionsToRender}
            surveyAnswers={surveyAnswers}
          />
        </div>
      ) : (
        <div
          key={reducerState.questionIdsToRender[currentQuestion]}
          className="mobile-view-individual-question-render"
        >
          <div className="progress-bar">
            <div
              style={{
                width: `${percentage}%`,
                backgroundColor: "#2863FF",
                height: "0.3em",
              }}
            ></div>
            <div className="progress-bar-percentage"></div>
          </div>
          <div className="mobile-view-individual-question-render-inner-container">
            {/* render question */}
            <div className="mobile-view-individual-question-serial-numb">
              {currentQuestion + 1}.{" "}
            </div>
            <span> &nbsp; </span>
            <div className="mobile-view-individual-question-render-text">
              <div className="mobile-view-question-render">
                <div
                  className="question-text"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      questionObjVariable?.[
                        reducerState?.questionIdsToRender[currentQuestion]
                      ]?.question
                    ),
                  }}
                ></div>
                {/* check mandatory or not */}

                {questionObjVariable?.[
                  reducerState?.questionIdsToRender[currentQuestion]
                ]?.validation?.mandatory?.isMandatory && (
                  <span className="question-text-is-mandatory">
                    (Mandatory)
                  </span>
                )}
              </div>
              {/* theme and category */}

              <div className="mobile-question-theme-category-cover">
                {questionObjVariable?.[
                  reducerState?.questionIdsToRender[currentQuestion]
                ]?.category && (
                  <div className="mobile-view-category-cover">
                    {truncateString(
                      questionObjVariable?.[
                        reducerState.questionIdsToRender[currentQuestion]
                      ]?.category?.name ||
                        questionObjVariable?.[
                          reducerState.questionIdsToRender[currentQuestion]
                        ]?.category,
                      30
                    )}
                  </div>
                )}
                {questionObjVariable?.[
                  reducerState?.questionIdsToRender[currentQuestion]
                ]?.theme && (
                  <div className="mobile-view-theme-cover">
                    {truncateString(
                      questionObjVariable?.[
                        reducerState.questionIdsToRender[currentQuestion]
                      ]?.theme,
                      30
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="mobile-view-current-question-container">
            {/* description  */}
            {questionObjVariable?.[
              reducerState?.questionIdsToRender[currentQuestion]
            ]?.description && (
              <div className="mobile-question-supplier-view-description">
                <span className="mobile-question-supplier-view-description-desc">
                  Description:{" "}
                </span>
                <span className="mobile-question-supplier-view-desc">
                  {" "}
                  {
                    questionObjVariable?.[
                      reducerState?.questionIdsToRender[currentQuestion]
                    ]?.description
                  }
                </span>
              </div>
            )}
            {/* custom comps */}
            <div className="questions-mobile-view-render-questions-container">
              {renderQuestionTypes(
                reducerState?.questionIdsToRender[currentQuestion]
              )}
            </div>
            {surveyAnswers?.[reducerState?.questionIdsToRender[currentQuestion]]
              ?.comment &&
              surveyAnswersInfo.surveyStatus !==
                EnumSurveyAnswerStatus?.COMPLETED && (
                <div className="mobile-view-question-render-note-cover">
                  <div className="mobile-note-cover">Note</div>

                  <div className="mobile-note-cover-comment">
                    {surveyAnswers?.[
                      reducerState?.questionIdsToRender[currentQuestion]
                    ]?.comment
                      ?.charAt(0)
                      .toUpperCase()}
                    {surveyAnswers?.[
                      reducerState?.questionIdsToRender[currentQuestion]
                    ]?.comment?.slice(1)}
                  </div>
                  {surveyAnswers?.[
                    reducerState?.questionIdsToRender[currentQuestion]
                  ]?.uploads!?.length > 0 && (
                    <div className="note-edit-cover">
                      <button
                        className={`is-note ${
                          reducerState.modalInfo.noteModalOpen
                            ? "active"
                            : "de-activate"
                        }`}
                        onClick={() => (
                          dispatch({
                            type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                            payload: {
                              modalType: EnumTypeTexts?.NOTE,
                              questionId:
                                reducerState.questionIdsToRender[
                                  currentQuestion
                                ],
                            },
                          }),
                          dispatch({
                            type: ActionKind.SET_NOTE_STATE_FROM_SURVEY_ANSWER,
                            payload: surveyAnswers,
                          })
                        )}
                      >
                        <span>
                          <img
                            className="clear-answer-img"
                            src={images.edit}
                            alt="Add Note"
                          />
                          Edit Note
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              )}
            {surveyAnswers?.[reducerState?.questionIdsToRender[currentQuestion]]
              ?.uploads!?.length > 0 && (
              <div className="mobile-view-question-render-uploaded-attachments">
                <div className="mobile-view-files-added-right-cover">
                  <div className="mobile-view-right-content">
                    <span className="mobile-files-added">Attachment</span>
                  </div>
                  <div className="mobile-view-right-uploaded">
                    {surveyAnswers?.[
                      reducerState?.questionIdsToRender[currentQuestion]
                    ]?.uploads!?.map((downloadedData: any) => {
                      return (
                        <>
                          <div
                            key={downloadedData?.key}
                            className="mobile-view-right-downloaded-files"
                          >
                            <span className="uploaded-files">
                              <span>
                                <img
                                  className="upload-pdf-img"
                                  src={images.pdfFile}
                                  alt="clear answer"
                                  style={{
                                    height: "1.9em",
                                  }}
                                />
                              </span>
                              &nbsp;
                              <span className="mobile-view-downloaded-files">
                                {downloadedData?.name}
                              </span>
                            </span>

                            <span
                              onClick={() => {
                                confirmDeleteFile(
                                  downloadedData?.Key,
                                  reducerState?.questionIdsToRender[
                                    currentQuestion
                                  ]
                                );
                              }}
                              className="delete-attached-file"
                            >
                              {" "}
                              <img
                                src={images.Delete}
                                height={18}
                                alt="delete-icon"
                              />
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
            {/* note and attachment */}
            <div className="mobile-view-note-and-attachment-cover">
              <div
                className={`mobile-view-note-and-attachment-wrapper ${
                  !surveyAnswers?.[
                    reducerState?.questionIdsToRender[currentQuestion]
                  ]
                    ? "mobile-view-note-and-attachment-wrapper"
                    : "mobile-view-note-and-attachment-wrapper-when-clear-answer-is-true"
                }`}
              >
                {surveyAnswersInfo.surveyStatus !==
                  EnumSurveyAnswerStatus?.COMPLETED && (
                  <div className="note-cover-no-clear-answer">
                    <button
                      className={`is-note ${
                        reducerState.modalInfo.noteModalOpen
                          ? "active"
                          : "de-activate"
                      }`}
                      onClick={() => (
                        dispatch({
                          type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                          payload: {
                            modalType: EnumTypeTexts?.NOTE,
                            questionId:
                              reducerState.questionIdsToRender[currentQuestion],
                          },
                        }),
                        dispatch({
                          type: ActionKind.SET_NOTE_STATE_FROM_SURVEY_ANSWER,
                          payload: surveyAnswers,
                        })
                      )}
                    >
                      {surveyAnswers?.[
                        reducerState?.questionIdsToRender[currentQuestion]
                      ]?.comment ? (
                        <span>
                          {!surveyAnswers?.[
                            reducerState?.questionIdsToRender[currentQuestion]
                          ]?.uploads!?.length && (
                            <>
                              <img
                                className="clear-answer-img"
                                src={images.edit}
                                alt="edit Note"
                              />
                              Edit Note
                            </>
                          )}
                        </span>
                      ) : (
                        <span>
                          <img
                            className="clear-answer-img"
                            src={images.path}
                            alt="Add Note"
                          />
                          Add Note
                        </span>
                      )}
                    </button>
                  </div>
                )}

                {questionObjVariable?.[
                  reducerState?.questionIdsToRender[currentQuestion]
                ]?.questionType !== EnumQuestionType.FILE && (
                  <div className="attachment-cover-no-clear-answer">
                    <button
                      className={`is-attachment ${
                        reducerState.modalInfo.attachmentModalOpen
                          ? "attachment-active"
                          : "attachment-de-activate"
                      }`}
                      onClick={() =>
                        dispatch({
                          type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                          payload: {
                            modalType: EnumTypeTexts?.ATTACHMENTS,
                            questionId:
                              reducerState?.questionIdsToRender[
                                currentQuestion
                              ],
                          },
                        })
                      }
                    >
                      <span
                        className="mobile-responsive-add-attachment"
                        style={{ minWidth: "8em" }}
                      >
                        Add Attachment
                      </span>{" "}
                      {reducerState?.uploadedFiles?.get(
                        reducerState?.questionIdsToRender[currentQuestion]
                      )!?.selectedFiles?.length > 0 && (
                        <div className="mobile-view-total-count">
                          {
                            reducerState?.uploadedFiles?.get(
                              reducerState?.questionIdsToRender[currentQuestion]
                            )!?.selectedFiles?.length
                          }
                        </div>
                      )}
                    </button>
                  </div>
                )}

                {surveyAnswers?.[
                  reducerState?.questionIdsToRender[currentQuestion]
                ] && (
                  <div className="mobile-supplier-view-question-clear-answer-cover">
                    {surveyAnswersInfo?.surveyStatus !==
                      EnumSurveyAnswerStatus?.COMPLETED && (
                      <>
                        <div
                          className="mobile-view-info-clear-answers"
                          onClick={() =>
                            handleClearAnswer(
                              reducerState?.questionIdsToRender[
                                currentQuestion
                              ],
                              surveyAnswersInfo?.surveyInfo?.questionsInfo
                                ?.questionObj[
                                reducerState?.questionIdsToRender[
                                  currentQuestion
                                ]
                              ]?.questionType
                            )
                          }
                        >
                          <span className="mobile-view-clear-answer-text">
                            Clear answer{" "}
                            <img
                              className="clear-answer-img"
                              src={images.ClearAnswerIcon}
                              alt="clear answer"
                            />
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* add note modal dialog */}
          <Dialog
            open={reducerState?.modalInfo?.noteModalOpen}
            className="mobile-view-add-note-modal"
            onClose={() =>
              dispatch({
                type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                payload: {
                  modalType: EnumTypeTexts?.NOTE,
                },
              })
            }
            aria-labelledby="form-dialog-title"
            PaperProps={{
              style: {
                width: "400px",
                height: "350px",
              },
            }}
          >
            <DialogTitle className="mobile-view-note-dialog-header">
              <div className="mobile-view-note-add-modal-title-container">
                <span>NOTE</span>
                <span
                  className="mobile-view-note-close"
                  onClick={() =>
                    dispatch({
                      type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                      payload: {
                        modalType: EnumTypeTexts?.NOTE,
                      },
                    })
                  }
                >
                  {icons.cross}
                </span>
              </div>
            </DialogTitle>
            <Divider />
            <DialogContent className="mobile-view-dialog-content-container">
              <div className="mobile-view-modal-content">
                <div className="input-cover">
                  <textarea
                    className="input-textarea"
                    placeholder="Enter a Note"
                    onChange={(event) =>
                      !isPreview &&
                      surveyAnswersInfo?.surveyStatus !==
                        EnumSurveyAnswerStatus?.COMPLETED &&
                      handleChangeAddComment(event)
                    }
                    value={
                      reducerState?.noteState?.[
                        reducerState?.modalNoteAndAttQuestionId
                      ] || ""
                    }
                    disabled={
                      isPreview ||
                      surveyAnswersInfo?.surveyStatus ===
                        EnumSurveyAnswerStatus?.COMPLETED
                    }
                  />
                </div>
              </div>
            </DialogContent>
            <DialogActions className="mobile-view-dialog-action-container-cover">
              <div className="mobile-view-dialog-action-container-wrapper">
                <div className="mobile-view-note-cancel-cover">
                  <button
                    className="mobile-view-note-cancel"
                    onClick={() =>
                      dispatch({
                        type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                        payload: {
                          modalType: EnumTypeTexts.NOTE,
                        },
                      })
                    }
                  >
                    Cancel
                  </button>
                </div>
                <div className="mobile-view-note-save-cover">
                  <button
                    className={
                      !isPreview &&
                      surveyAnswersInfo?.surveyStatus !==
                        EnumSurveyAnswerStatus?.COMPLETED
                        ? "mobile-view-note-save is-preview-active-save"
                        : "mobile-view-note-save is-preview-disabled-save"
                    }
                    onClick={() => (
                      handleNoteComment(reducerState.modalNoteAndAttQuestionId),
                      !isPreview &&
                        surveyAnswersInfo?.surveyStatus !==
                          EnumSurveyAnswerStatus?.COMPLETED &&
                        dispatch({
                          type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                          payload: {
                            modalType: EnumTypeTexts?.NOTE,
                          },
                        })
                    )}
                  >
                    {surveyAnswers?.[reducerState?.modalNoteAndAttQuestionId]
                      ?.comment
                      ? "Update"
                      : "Add"}
                  </button>
                </div>
              </div>
            </DialogActions>
          </Dialog>
          {/* add attachment modal dialog */}
          <Dialog
            open={reducerState?.modalInfo?.attachmentModalOpen}
            className="mobile-view-attachment-add-section-modal"
            onClose={() =>
              dispatch({
                type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                payload: {
                  modalType: EnumTypeTexts?.ATTACHMENTS,
                },
              })
            }
            aria-labelledby="form-dialog-title"
            PaperProps={{
              style: {
                width: "600px",
                height: "500px",
              },
            }}
          >
            <DialogTitle className="mobile-view-attachment-dialog-header">
              <div className="mobile-view-attachment-add-modal-title-container">
                <h4>Attachments</h4>
                <span
                  className="mobile-view-attachments-close"
                  onClick={() =>
                    dispatch({
                      type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                      payload: {
                        modalType: EnumTypeTexts?.ATTACHMENTS,
                      },
                    })
                  }
                >
                  {icons.cross}
                </span>
              </div>
            </DialogTitle>
            <DialogContent className="mobile-view-attachments-dialog-content-container">
              <div className="mobile-view-attachments-modal-content-wrapper">
                <div className="mobile-view-attachments-modal-left-main-cover">
                  <div className="mobile-view-attachments-input-cover">
                    <input
                      type="file"
                      className="file-input"
                      id="file-upload"
                      multiple
                      style={{ display: "none" }}
                      onChange={(event) =>
                        !isPreview &&
                        surveyAnswersInfo?.surveyStatus !==
                          EnumSurveyAnswerStatus?.COMPLETED &&
                        dispatch({
                          type: ActionKind.HANDLE_FILE_CHANGE,
                          payload: {
                            files: event.currentTarget.files,
                          },
                        })
                      }
                      disabled={
                        isPreview ||
                        surveyAnswersInfo.surveyStatus ===
                          EnumSurveyAnswerStatus?.COMPLETED
                      }
                    />
                  </div>
                  <div className="mobile-view-attachment-label-cover">
                    <label
                      htmlFor="file-upload"
                      className="file-upload-label"
                      style={{
                        border: "2px dashed  rgb(40, 99, 255);",
                        fontSize: "12px",
                        fontWeight: "500",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "2em",
                        color: " rgb(40, 99, 255)",
                        borderRadius: "4px",
                        cursor: "pointer",
                        height: "10em",
                        width: "auto",
                        position: "relative",
                        backgroundColor: "rgb(242, 246, 255)",
                      }}
                    >
                      <span
                        className="browse-file"
                        style={{
                          height: "30%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          className="mobile-view-cloud-upload-file"
                          src={images.CloudUpload}
                          alt="cloud-upload"
                        />
                      </span>
                      Browse file{" "}
                    </label>
                  </div>
                  <div className="mobile-view-attachment-left-added-file-cover">
                    {reducerState?.uploadedFiles?.get(
                      reducerState?.modalNoteAndAttQuestionId
                    )?.selectedFiles.length! > 0 ? (
                      <div className="mobile-view-files-added-left-cover">
                        <div className="mobile-view-left-uploaded">
                          {reducerState?.uploadedFiles
                            .get(reducerState?.modalNoteAndAttQuestionId)!
                            .selectedFiles?.map(
                              (addedData: any, index: number) => (
                                <div className="mobile-view-uploaded-files">
                                  <li className="mobile-view-files">
                                    <div className="mobile-view-added-uploaded-files">
                                      {addedData?.name} &nbsp;
                                      <span style={{ color: "#858585" }}>
                                        ({(addedData?.size / 1024).toFixed(2)}
                                        KB)
                                      </span>
                                    </div>
                                    <span
                                      className="mobile-supplier-close-button"
                                      onClick={() => {
                                        removeAttachedFile(addedData?.name);
                                      }}
                                    >
                                      X
                                    </span>
                                  </li>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                    ) : (
                      <div className="mobile-view-left-no-files-added">
                        <div>
                          {" "}
                          <img
                            className="mobile-view-cloud-upload-file"
                            src={images.attachment}
                            alt="cloud-upload"
                          />
                        </div>
                        <div>No files attached</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </DialogContent>
            <DialogActions className="attachments-dialog-action-container-cover">
              <div className="attachments-dialog-action-container-wrapper">
                <button
                  className={"cancel-btn-submission blue"}
                  onClick={() =>
                    dispatch({
                      type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                      payload: {
                        modalType: EnumTypeTexts.ATTACHMENTS,
                      },
                    })
                  }
                >
                  Cancel
                </button>
              </div>
              <div className="attachments-dialog-action-container-wrapper">
                <button
                  className={"add-btn-submission blue"}
                  onClick={() =>
                    dispatch({
                      type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                      payload: {
                        modalType: EnumTypeTexts.ATTACHMENTS,
                      },
                    })
                  }
                >
                  Add
                </button>
              </div>
            </DialogActions>
          </Dialog>
        </div>
      )}
      {!allQuestions && (
        <div className="questions-mobile-view-footer-container">
          <div
            className={`questions-mobile-view-previous-button ${
              currentQuestion === 0 ? "disabled" : "enabled"
            }`}
            onClick={() => {
              currentQuestion !== 0 && handlePrevAndNextQuestion("prev");
            }}
          >
            <img src={images.next} alt="next-arrow" />
            <span className="previous-button">Previous</span>
          </div>

          <div
            ref={disableButton}
            className="questions-mobile-view-next-button"
            onClick={() => {
              handlePrevAndNextQuestion("next");
            }}
          >
            {currentQuestion === reducerState?.questionIdsToRender?.length - 1
              ? "Submit"
              : "Save & Next"}
            <img
              src={images.previous}
              alt="prev-arrow"
              style={{ paddingLeft: "10px" }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default QuestionsMobileView;
